export const SELECTOR_ID = "select";

export enum Button_Names {
  Save_Changes = "Save Changes",
  Reset = "Reset",
  Cancel = "Cancel",
  Discard_Change = "Discard",
  Submit = "Submit",
  Next = "Next",
  Back = "Back",
  Remove = "Remove",
}

export enum Action_Type {
  Add = "Add",
  Edit = "Edit",
  Delete = "Delete",
  View = "View",
}

export const GLOBAL_ERROR_MESSAGE =
  "Something went wrong. Please try again later.";

export const DELETE_CONFIRMATION_CONSTANTS = {
  title: "Are you sure?",
  btnName: "Yes, Delete It",
  cancelName: "No, Cancel",
};

export const FILE_SIZE_ERROR_MESSAGE = {
  LESS_THAN_1MB: "File size should be less than 1 MB",
  LESS_THAN_4MB: "File size should be less than 4 MB",
};

export enum REQUEST_METHODS {
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export const GENERAL_KEYS = {
  Id: "id",
};
